export default "__VITE_ASSET__0849b985__"